import { getServiceHealthUrl } from '../config/apiConfig';

export const fetchServiceHealth = async () => {
  const url = getServiceHealthUrl();

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      try {
        const errorJson = await response.json();
        const serverMsg = errorJson.message || errorJson.error || errorJson.status;
        if (serverMsg) {
          throw new Error(`HTTP ${response.status}: ${serverMsg}`);
        }
      } catch (e) {
        if (e.message?.startsWith('HTTP ')) {
          throw e;
        }
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText || 'Server Error'}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    let message = error.message;
    if (error.name === 'AbortError') {
      message = 'Request timed out';
    }
    return { data: null, error: message };
  }
};
